export var replaceThemeToken = function replaceThemeToken(currentValue, theme) {
  var updated = false;
  var value = currentValue;

  if (typeof currentValue === 'string' && currentValue[0] === '$') {
    if (currentValue in theme.referenceIndex) {
      value = theme.referenceIndex[currentValue];
      updated = true;
    } else {}
  }

  return {
    value: value,
    updated: updated
  };
};